module.exports = __webpack_public_path__ + "img/logo3.205b2702.png";